import { useState } from 'react';
import { NumberFormatStyle  } from '@shared/utils/constants';

const useNumberFormatStyle = (defaultFormatStyle: NumberFormatStyle = NumberFormatStyle.UkUs) => {
	const [formatStyle, setFormatStyle] = useState<NumberFormatStyle>(defaultFormatStyle);

	return { formatStyle, setFormatStyle };
};

export default useNumberFormatStyle;